<div class="my-shopping">
    <div class="title">
        <h2>Compras</h2>
        <p>Aquí podrás ver y gestionar todas tus compras online.</p>
    </div>

    <div class="product" *ngFor="let item of transactions">
        <div class="header">
            <div style="margin-right: auto;">
                <h3>{{ item.created_at | date:'dd-MM-yyyy' }}</h3>
                <p>Compra Nº: <span>#{{ item.id }}</span></p>
            </div>
            <!--<button mat-flat-button>Ver detalle</button>-->
        </div>
        
        <div class="body" *ngFor="let prod of item.items">
            <a [routerLink]="['/producto/' + prod.product_id + '/' + processProductTitle(prod.product)]" class="image-container">
                <img [src]="prod.product.photo_feature" onerror="this.src='/assets/img/image-not-found.png';" />
            </a>
            <div class="texts">
                <div *ngIf="item.status == 0" class="arrives arrives-pending">
                    <span class="material-icons">departure_board</span> Pendiente
                </div>
                <div *ngIf="item.status == 1" class="arrives arrives-on">
                    <span class="material-icons">departure_board</span> Pendiente
                </div>
                <div *ngIf="item.status == 2" class="arrives arrives-canceled">
                    <span class="material-icons">close</span> Cancelado
                </div>
                <div *ngIf="item.status == 3" class="arrives arrives-canceled">
                    <span class="material-icons">close</span> Devuelto
                </div>
                <div *ngIf="item.status == 4" class="arrives arrives-on">
                    <span class="material-icons">departure_board</span> Entrega Pendiente
                </div>
                <div *ngIf="item.status == 5" class="arrives arrives-pending">
                    <span class="material-icons">departure_board</span> Entrega Pendiente
                </div>
                <div *ngIf="item.status == 6" class="arrives arrives-on">
                    <span class="material-icons">local_shipping</span> Entregado
                </div>
                
                <a [routerLink]="['/producto/' + prod.product_id + '/' + processProductTitle(prod.product)]" ><h4>{{ prod.product.title }}</h4></a>
                <!--<p>Color Negro</p>-->
                <p>x {{ prod.quantity }} unidad</p>
            </div>
        </div>
    </div>

</div>